var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaterSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#1457A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25H25.1667",
    stroke: "#FFFEE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25V22H19.5V25",
    stroke: "#FFFEE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21L20.625 17.1534C20.7314 17.0541 20.8637 17 21 17C21.1363 17 21.2686 17.0541 21.375 17.1534L25.5 21",
    stroke: "#FFFEE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20V25",
    stroke: "#FFFEE2",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20V25",
    stroke: "#FFFEE2",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14L17.5 14",
    stroke: "#FFFEE2",
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17H18.5",
    stroke: "#FFFEE2",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17V14.5C18.5 13.5717 18.0786 12.6815 17.3284 12.0251C16.5783 11.3687 15.5609 11 14.5 11C13.4391 11 12.4217 11.3687 11.6716 12.0251C10.9214 12.6815 10.5 13.5717 10.5 14.5V25",
    stroke: "#FFFEE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSource);
export default __webpack_public_path__ + "static/media/waterSource.0b2c43c99d5cb978d7d7dcfe71a2f832.svg";
export { ForwardRef as ReactComponent };